// JavaScript Document

$(document).foundation();

$(window).load(function() {
    $("#status").fadeOut();
    $("#preloader").delay(1000).fadeOut("slow");
});

$('.open_search_box_cls').click(function(){
  setTimeout(function(){
    $('.search_popup_field').focus();
  },500);
  
});

/*---------   Sliders   ---------*/

$(document).ready(function(e) {
  
  $('.grid-1').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false
  });

  $('.grid-2').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.grid-3').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.grid-4').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.grid-5').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });


  $('.home1-slider ul').slick({
    dots: false,
    arrows:true,
    infinite: true,
    speed:800,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    slide:'li',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '40px',
          variableWidth: false
        }
      },
      {
        breakpoint: 640,
        settings: {
          centerPadding: '0px',
          variableWidth: false
        }
      }
    ]
  });

  /*
	$('.home2-slider ul').slick({
	  //infinite: true,
	  arrows: true,
	  dots: false,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  slide: 'li',
	  autoplay: false
	});
	*/

  $('.home3-slider ul').slick({
    //infinite: true,
    arrows: false,
    dots: true,
    fade:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false
  });

});

var grid_1_var, grid_2_var, grid_3_var, grid_4_var, grid_5_var, grid_6_var;

grid_1_var = $('.grid_1_flex_slider').width();
grid_2_var = $('.grid_2_flex_slider').width()/2;
grid_3_var = $('.grid_3_flex_slider').width()/3;
grid_4_var = $('.grid_4_flex_slider').width()/4;
grid_5_var = $('.grid_5_flex_slider').width()/5;
grid_6_var = $('.grid_6_flex_slider').width()/6;

if ($(window).width() < 1024) {
  grid_1_var = $(window).width();
  grid_2_var = $(window).width()/2;
  grid_3_var = $(window).width()/2;
  grid_4_var = $(window).width()/3;
  grid_5_var = $(window).width()/3;
  grid_6_var = $(window).width()/4;
}

if ($(window).width() < 768) {
  grid_1_var = $(window).width();
  grid_2_var = $(window).width()/1;
  grid_3_var = $(window).width()/2;
  grid_4_var = $(window).width()/2;
  grid_5_var = $(window).width()/2;
  grid_6_var = $(window).width()/3;
}

if ($(window).width() < 568) {
  grid_1_var = $(window).width();
  grid_2_var = $(window).width();
  grid_3_var = $(window).width();
  grid_4_var = $(window).width();
  grid_5_var = $(window).width();
  grid_6_var = $(window).width()/2;
}

var grid_1_code = $('.grid_1_flex_slider').flexslider({
  animation: "slide",
  animationLoop: false,
  controlNav: false,
  itemWidth: grid_1_var,
  nextText: "",
  prevText: "",
  itemMargin: 0,
  minItems: 1,
  maxItems: 1,
  touch:true,
  slideshow: false,
  move: 1
});

var grid_2_code = $('.grid_2_flex_slider').flexslider({
  animation: "slide",
  animationLoop: false,
  controlNav: false,
  itemWidth: grid_2_var,

  nextText: "",
  prevText: "",
  itemMargin: 0,
  minItems: 1,
  maxItems: 2,
  touch:true,
  slideshow: false,
  move: 1
});

var grid_3_code = $('.grid_3_flex_slider').flexslider({
  animation: "slide",
  animationLoop: false,
  controlNav: false,
  itemWidth: grid_3_var,
  nextText: "",
  prevText: "",
  itemMargin: 0,
  minItems: 1,
  maxItems: 3,
  touch:true,
  slideshow: false,
  move: 1
});

var grid_4_code = $('.grid_4_flex_slider').flexslider({
  animation: "slide",
  animationLoop: false,
  controlNav: false,
  itemWidth: grid_4_var,
  nextText: "",
  prevText: "",
  itemMargin: 0,
  minItems: 1,
  maxItems: 4,
  touch:true,
  slideshow: false,
  move: 1
});

var grid_5_code = $('.grid_5_flex_slider').flexslider({
  animation: "slide",
  animationLoop: false,
  controlNav: false,
  itemWidth: grid_5_var,
  nextText: "",
  prevText: "",
  itemMargin: 0,
  minItems: 1,
  maxItems: 5,
  touch:true,
  slideshow: false,
  move: 1
});

var grid_6_code = $('.grid_6_flex_slider').flexslider({
  animation: "slide",
  animationLoop: true,
  controlNav: false,
  itemWidth: grid_6_var,
  nextText: "",
  prevText: "",
  itemMargin: 0,
  minItems: 2,
  maxItems: 6,
  touch:true,
  slideshow: true,
  move: 1
});

var home_slider_code = $('.home-slider').slick({
  speed: 1200,
  slidesToShow: 1,
  arrows: true,
  dots: true,
  touchMove: false,
  slide: 'li',
  //fade:true,
  autoplay: false,
  //infinite:false,
  dotsClass: 'custom-paging',
  customPaging: function(slider, i) {
    return '0' + (i + 1) + ' ' + '<span>' + '/' + ' ' + '0' + slider.slideCount + '</span>';
  }
});

$(window).load(function() {
  grid_1_code.load();
  grid_2_code.load();
  grid_3_code.load();
  grid_4_code.load();
  grid_5_code.load();
  grid_6_code.load();
  home_slider_code.load();
  
  setTimeout(function(){
    grid_1_code.resize();
    grid_2_code.resize();
    grid_3_code.resize();
    grid_4_code.resize();
    grid_5_code.resize();
    grid_6_code.resize();
    home_slider_code.resize();
  },500);
});

function grid_function_custom(){
  var grid_1_var, grid_2_var, grid_3_var, grid_4_var, grid_5_var, grid_6_var;
  grid_1_var = $('.grid_1_flex_slider').width();
  grid_2_var = $('.grid_2_flex_slider').width()/2;
  grid_3_var = $('.grid_3_flex_slider').width()/3;
  grid_4_var = $('.grid_4_flex_slider').width()/4;
  grid_5_var = $('.grid_5_flex_slider').width()/5;
  grid_6_var = $('.grid_6_flex_slider').width()/6;
  
  var grid_1_code = $('.grid_1_flex_slider').flexslider({
    animation: "slide",
    animationLoop: false,
    controlNav: false,
    itemWidth: grid_1_var,
    nextText: "",
    prevText: "",
    itemMargin: 0,
    minItems: 1,
    maxItems: 2,
    touch:true,
    slideshow: false,
    move: 1
  });
  
  var grid_2_code = $('.grid_2_flex_slider').flexslider({
    animation: "slide",
    animationLoop: false,
    controlNav: false,
    itemWidth: grid_2_var,
    nextText: "",
    prevText: "",
    itemMargin: 0,
    minItems: 1,
    maxItems: 2,
    touch:true,
    slideshow: false,
    move: 1
  });
  
  var grid_3_code = $('.grid_3_flex_slider').flexslider({
    animation: "slide",
    animationLoop: false,
    controlNav: false,
    itemWidth: grid_3_var,
    nextText: "",
    prevText: "",
    itemMargin: 0,
    minItems: 1,
    maxItems: 3,
    touch:true,
    slideshow: false,
    move: 1
  });
  
  var grid_4_code = $('.grid_4_flex_slider').flexslider({
    animation: "slide",
    animationLoop: false,
    controlNav: false,
    itemWidth: grid_4_var,
    nextText: "",
    prevText: "",
    itemMargin: 0,
    minItems: 1,
    maxItems: 4,
    touch:true,
    slideshow: false,
    move: 1
  });

  var grid_5_code = $('.grid_5_flex_slider').flexslider({
    animation: "slide",
    animationLoop: false,
    controlNav: false,
    itemWidth: grid_5_var,
    nextText: "",
    prevText: "",
    itemMargin: 0,
    minItems: 1,
    maxItems: 5,
    touch:true,
    slideshow: false,
    move: 1
  });
  
  var grid_6_code = $('.grid_6_flex_slider').flexslider({
    animation: "slide",
    animationLoop: true,
    controlNav: false,
    itemWidth: grid_6_var,
    nextText: "",
    prevText: "",
    itemMargin: 0,
    minItems: 2,
    maxItems: 6,
    touch:true,
    slideshow: true,
    move: 1
  });
  
  var home_slider_code = $('.home-slider').slick({
    speed: 1200,
    slidesToShow: 1,
    arrows: true,
    dots: true,
    touchMove: false,
    slide: 'li',
    //fade:true,
    autoplay: false,
    //infinite:false,
    dotsClass: 'custom-paging',
    customPaging: function(slider, i) {
      return '0' + (i + 1) + ' ' + '<span>' + '/' + ' ' + '0' + slider.slideCount + '</span>';
    }
  });
  
  grid_1_code.load();
  grid_2_code.load();
  grid_3_code.load();
  grid_4_code.load();
  grid_5_code.load();
  grid_6_code.load();
  home_slider_code.load();
  
  setTimeout(function(){
    grid_1_code.resize();
    grid_2_code.resize();
    grid_3_code.resize();
    grid_4_code.resize();
    grid_5_code.resize();
    grid_6_code.resize();
    home_slider_code.resize();
  },500);
}

/*---------   Tab Slick   ---------*/

$(document).ready(function(e) {
	
  $('.tab-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.decrease-qty').on('click', function() {
    var count = $(this).siblings(".product_qty_input");
    var val = parseInt(count.val());
    if (val > 1)
      count.val(val - 1);
  });
  $('.increase-qty').on('click', function() {
    var count = $(this).siblings(".product_qty_input");
    var val = parseInt(count.val());
    count.val(val + 1);
  });

  $(".product-tab .tabs-title>a").click(function(event) {

    event.preventDefault();
    $('.tab-slider').slick("unslick");

    var tab = $(this).attr("href");
    $(tab).fadeIn();
    $(".tabs-panel").not(tab).css("display", "none");

    $('.tab-slider').slick({
      arrows: true,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      slide: 'li',
      autoplay: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 568,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

  });

});

/*---------   Mobile Menu   ---------*/

$('header .menu-icon, .side-menu .close-button').click(function(e) {
  $(".app-container").toggleClass("expanded");
});

$('.menu-icon').click(function(e) {
  $(".productbar-wrap").slideToggle();
});


$('.submenu-parent').each(function(index, element) {
  $(this).append('<span></span>');	
});

$('.submenu-parent span').on('click', function (e) {

  var submenu =  $(this).closest('.submenu-parent').find('>.sub-menu');	

  if( submenu.is(":visible") == true ){

    submenu.slideUp();	
    $(this).closest('.submenu-parent').removeClass('active');	

  }
  else{
    //$('.submenu-parent>ul.sub-menu').removeClass('active').slideUp();	
    submenu.slideDown();
    $(this).closest('.submenu-parent').addClass('active');		 

  }

  e.preventDefault();	 
});

$('.sub-menu .submenu-parent span').on('click', function (e) {

  var grandsubmenu =  $(this).closest('.submenu-parent').find('>.grand-submenu');	

  if( grandsubmenu.is(":visible") == true ){

    grandsubmenu.slideUp();	
    $(this).closest('.submenu-parent').removeClass('active');	 		  
  }
  else{

    //$('.submenu-parent > ul.grand-submenu').removeClass('active').slideUp();	
    grandsubmenu.slideDown();		 
    $(this).closest('.submenu-parent').addClass('active');

    if( $(this).closest('.submenu-parent').hasClass('active') ){

      console.log('hi');
      $(this).closest('.sub-menu').slideDown();	

    }
    else{
      // $(this).closest('.sub-menu').slideUp();

    }
  }
  e.preventDefault();

});


/*---------   Header Fix   ---------*/

$(window).scroll(function() {
  if ($(this).scrollTop() >= 1) {
    $('.main-header').addClass('stickytop');
  }
  else {
    $('.main-header').removeClass('stickytop');
  }
});


/*---------   Slider Img In Bg   ---------*/

$(window).load(function(e) {

  jQuery('.slider-img').each(function() {

    var el = $(this),
        src = el.attr('src'),
        parent = el.parent();
    height = $(window).height() - $('header').innerHeight();

    parent.css({
      'background-image': 'url(' + src + ')',
      'background-size': 'cover',
      'background-position': 'center',
      'height':height
    });

    el.hide();
  });

  jQuery('.bg-img').each(function() {

    var el = $(this),
        src = el.attr('src'),
        parent = el.parent();
    height = $(this).height();

    parent.css({
      'background-image': 'url(' + src + ')',
      'background-size': 'cover',
      'background-position': 'center',
      'height':height
    });

    el.hide();
  });

 /*
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       100,          // distance to the element when triggering the animation (default is 0)
        mobile:       true,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
    wow.init();
  */

});

/*---------   Counter   ---------*/

var end_day_sale_date_1 = $('.end_day_sale_date_1').attr('data-date');
var end_day_sale_date_2 = $('.end_day_sale_date_2').attr('data-date');

$(window).load(function() {
  $('#counter_desk').countdowntimer({
      dateAndTime: end_day_sale_date_1,
      size: "lg",
      regexpMatchFormat: "([0-9]{1,3}):([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})",
      regexpReplaceWith: "<span class='displayformat'>$1<p>Days</p></span><span class='displayformat'>$2<p>Hours</p></span><span class='displayformat'>$3<p>Mins</p></span><span class='displayformat'>$4<p>Secs</p></span>"
    });
    
    $('#counter_mobile').countdowntimer({
      dateAndTime: end_day_sale_date_1,
      size: "lg",
      regexpMatchFormat: "([0-9]{1,3}):([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})",
      regexpReplaceWith: "<span class='displayformat'>$1<p>Days</p></span><span class='displayformat'>$2<p>Hours</p></span><span class='displayformat'>$3<p>Mins</p></span><span class='displayformat'>$4<p>Secs</p></span>"
    });
  
  $('#white_counter').countdowntimer({
    dateAndTime: end_day_sale_date_2,
    size: "lg",
    regexpMatchFormat: "([0-9]{1,3}):([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})",
    regexpReplaceWith: "<span class='displayformat'>$1<p>Days</p></span><span class='displayformat'>$2<p>Hours</p></span><span class='displayformat'>$3<p>Mins</p></span><span class='displayformat'>$4<p>Secs</p></span>"
  });
});